import { ApiClient, RequestOptions } from "../ApiClient";
import { EnvConfig } from "../config";

const assetManagementApiClients: Record<string, AssetManagementApiClient> = {};

export const getAssetManagementApiClient = (config: EnvConfig): AssetManagementApiClient => {
    const { assetManagementApiBaseUrl, authIssuer, authScope, authClientId } = config;
    const key = `${assetManagementApiBaseUrl}-${authIssuer}-${authScope}-${authClientId}`;
    if (!assetManagementApiClients[key]) {
        assetManagementApiClients[key] = new AssetManagementApiClient(config);
    }
    return assetManagementApiClients[key];
};

export class AssetManagementApiClient extends ApiClient {
    /**
     * Request function to send an authenticated POST request to the AssetManagementAPI
     */
    async request<T>(path: string, options?: RequestOptions<T>): Promise<T> {
        if (this.config.useMockData) {
            return this.mockRequest<T>(options?.mockResponse as T);
        }

        if (this.authClientServiceCalls === null) {
            return Promise.reject("AuthClient not initialized");
        }
        const { method = "POST", headers: additionalHeaders = {}, body: bodyObject } = options || {};
        const headers = {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
            ...additionalHeaders
        };
        const body = bodyObject ? JSON.stringify(bodyObject) : undefined;
        return fetch(`${this.config.assetManagementApiBaseUrl}${path}`, {
            method,
            headers,
            body
        }).then((response) => {
            if (response.status === 401) {
                this.authClientServiceCalls.deleteAccessToken();
                return Promise.reject("Unauthorized");
            }
            if (response.status === 200) {
                return response.json();
            }
            return Promise.reject(`Error ${response.status}`);
        });
    }
}
